import { closeModalGlobal, openModalGlobal } from '../../../js/components/modal';
import { isLocalhost, isMobile } from "../../../js/modules/utilities";
import { loadRecaptcha } from '../../../js/components/load_recaptcha'

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const scheduleRecaptchaId = 'schedule-appointment';

const modalContent = document.querySelector('.schedule-appointment');
const appt = document.querySelector('.schedule-appointment');
const next = document.querySelector('.appointment_request.next');
const prev = document.querySelector('.previous');
const submit = document.querySelector('button.submit');
const done = document.querySelector('button.done');
const dropitems = document.querySelectorAll('.date-sort__cta');
const dropLists = document.querySelectorAll('.date-sort__list');
const monthSelect = document.querySelectorAll('#month-options > button');
const step1 = document.querySelector('.schedule-appointment__container.step-1');
const step2 = document.querySelector('.schedule-appointment__container.step-2');
const step3 = document.querySelector('.schedule-appointment__confirmation');
const step1span = document.querySelectorAll('span.step-1');
const step2span = document.querySelectorAll('span.step-2');
const tourType = document.querySelectorAll('.infoButton');
const timeList = document.querySelector('.time-selector');
const weekNext = document.querySelector('.week-btn.next');
const weekPrev = document.querySelector('.week-btn.prev');
const dayNext = document.querySelector('.date-control.next');
const dayPrev = document.querySelector('.date-control.prev');
const dateDisplay = document.querySelector('.day .info');
const contactInputs = document.querySelectorAll('.maa-input');

let propertyId, propertyTitle, bedData, propertyBeds;

if(modalContent){
  propertyId = modalContent.getAttribute('data-propertyid');
  propertyTitle = modalContent.getAttribute('data-propertyname');
  bedData = modalContent.getAttribute('data-bedrooms');
  propertyBeds = bedData.length > 0 ? bedData.split(",") : [];
}
const confTitleText = "We have received your info";
const confResponseText = "Thank you for your interest in scheduling a tour with us!  Our leasing team will be in touch with you regarding a confirmed tour date and time.  We look forward to welcoming you to our community!";
const errTitleText = "Uh oh! Something went wrong.";

//const timesUrl = '/assets/data/times.json';
const timesUrl = location.hostname == 'localhost' ? '/assets/data/times.json' : '/api/boardingpass/getavailableslots';
const boardingPassEndpoint = location.hostname == 'localhost' ? '/assets/data/boarding-pass.json' : '/api/boardingpass';
const boardingPassUrl = "/boarding-pass";
const boardingPassMethod = location.hostname == 'localhost' ? 'GET' : 'POST';

const formFields = ['first_name','last_name','email_address','phone_number'];
const MODAL_UNIQUE_ID = 'schedule-appointment';

let timeGroupSlides, timeGroupIndex, selectedDate, selectedTime, confBoardingPassUrl;

let step1Values = {
  tour_type: false,
  first_name: false,
  last_name: false,
  email_address: false,
  phone_number: false,
  tour_time: false,
};

let step2Values = {
  bedrooms: false,
  moving_month: false,
  moving_day: false,
  moving_year: false,
  captchaResponse: false
};

document.addEventListener('setRecaptcha', ((e) => {
  step2Values.captchaResponse = e.detail.recaptcha;
}));

const handleTimeSelect = (e) => {
  timeGroupSlides.forEach((slide) => {
    const timeBtns = slide.querySelectorAll('button.p1');
    timeBtns.forEach((btn) => {
      if(btn != e.currentTarget){
        btn.classList.remove('active');
      } else {
        btn.classList.add('active');
        selectedDate = btn.getAttribute('data-date');
        selectedTime = btn.getAttribute('data-time');
      }
    })
    document.querySelector('.week-selector').classList.remove('error');
  })

  step1Values.tour_time = { date: selectedDate, time: selectedTime};
}

const resetForm = () => {
  step1.classList.remove('active');
  step2.classList.remove('active');
  step3.classList.remove('active');
  step1span.forEach((item) => {
    item.classList.add('active');
  })
  step2span.forEach((item) => {
    item.classList.remove('active');
  })
  tourType.forEach((item) => {
    item.classList.remove('buttonSchedTourACTIVE');
    item.classList.add('buttonSchedTourINACTIVE');
  })
  next.classList.add('active');
  prev.classList.remove('active');
  submit.classList.remove('active');
  done.classList.remove('active');
}

const setDays = () => {
  document.getElementById('moving_day').classList.remove('valid');
  const dayOptions = document.getElementById("day-options");
  const dayOptionsMobile = document.getElementById("moving_day_mobile");
  dayOptions.innerHTML = "";
  dayOptionsMobile.innerHTML = "";

  let setMonth;

  if(isMobile){
    const monthSel = document.getElementById('moving_month_mobile');
    setMonth = monthSel.options[monthSel.selectedIndex].innerText;
  } else {
    //document.getElementById('moving_day').innerText = "Day";
    setMonth = document.getElementById('moving_month').innerText;
  }

  // BUILD DAYS
  const today = new Date();
  let setYear = today.getFullYear();

  if(isMobile){
    setYear = document.getElementById('moving_year_mobile').value;
    if(setYear == 0) setYear = today.getFullYear();
  } else {
    if(document.getElementById('moving_year').innerText != "Year") setYear = document.getElementById('moving_year').innerText;
  }

  const monthPtr = new Date(`${setMonth} 1, ${setYear}`);
  const lastDoM = new Date(monthPtr.getFullYear(), monthPtr.getMonth() + 1, 0);

  dayOptionsMobile.appendChild(createButtonMobile("Day",0));

  for (let index = 1; index <= lastDoM.getDate(); index++) {
    dayOptions.appendChild(createButton(index, handleDropSelectDay));
    dayOptionsMobile.appendChild(createButtonMobile(index, index));
  }

  const checkDate = new Date(`${step2Values.moving_month} ${step2Values.moving_day}, ${step2Values.moving_year}`);
  if(checkDate.getDate() != step2Values.moving_day || !step2Values.moving_day) {
    if(isMobile){
      dayOptionsMobile.value = 0;
    } else {
      document.getElementById('moving_day').innerText = "Day";
    }
    step2Values.moving_day = false;
  } else {
    if(isMobile){
      dayOptionsMobile.value = step2Values.moving_day;
    } else {
      document.getElementById('moving_day').classList.add('valid');
    }
  }
}

const handleDropSelectDay = (e) => {
  if(isMobile){
    step2Values.moving_day = document.getElementById('moving_day_mobile').value;
  } else {
    step2Values.moving_day = e.currentTarget.querySelector('.date-sort__list-cta').innerText;
    e.currentTarget.closest('.date-sort').querySelector('.date-sort__cta-text').innerText = step2Values.moving_day;
    e.currentTarget.closest('.date-sort').querySelector('.date-sort__cta-text').classList.add('valid');
    e.currentTarget.closest('.date-sort__list').classList.remove('active');
  }
}

const handleYearSelect = (e) => {
  if(isMobile){
    step2Values.moving_year = document.getElementById('moving_year_mobile').value;
  } else {
    step2Values.moving_year = e.currentTarget.querySelector('.date-sort__list-cta').innerText;
    e.currentTarget.closest('.date-sort').querySelector('.date-sort__cta-text').innerText = step2Values.moving_year;
    e.currentTarget.closest('.date-sort').querySelector('.date-sort__cta-text').classList.add('valid');
    e.currentTarget.closest('.date-sort__list').classList.remove('active');
  }

  setDays();
}

export const initAppointment = (e) => {
  resetForm();
  closeModalGlobal();
  openModalGlobal(modalContent, '100%', false, MODAL_UNIQUE_ID);
  modalContent.classList.add('active');
  loadRecaptcha(scheduleRecaptchaId);

  document.addEventListener('g-captcha', (e) => {
    if (e.detail.id === scheduleRecaptchaId) {
      step2Values.captchaResponse = e.detail.captchaKey;
    }
  });

  fetch(`${timesUrl}?propertyId=${propertyId}`)
    .then(res => res.json())
    .then(res => {
      if(res.success){
        timeList.innerHTML = '';
        res.availableSlots.forEach((times, index) => {
          const timeGroup = document.createElement('DIV');
          timeGroup.classList.add('time-group');
          timeGroup.setAttribute('data-date', times.ActualDate);
          timeGroup.setAttribute('data-title', times.DateDesc);
          if(index == 0) {
            timeGroup.classList.add('active');
            dateDisplay.innerText = times.DateDesc;
          }

          if(times.Hours.length > 0){
            times.Hours.forEach((time) => {
              const timeItem = document.createElement('DIV');
              const timeButton = document.createElement('BUTTON');
              timeItem.classList.add('time');
              timeButton.classList.add('p1');
              timeButton.textContent = time;
              timeButton.setAttribute('data-time', time);
              timeButton.setAttribute('data-date', times.ActualDate);
              timeButton.addEventListener('click', handleTimeSelect);
              timeItem.appendChild(timeButton);
              timeGroup.appendChild(timeItem)
            })
          } else {
            timeGroup.classList.add('no-times');
          }

          timeList.appendChild(timeGroup);
          timeGroupIndex = 0;
        })

        timeGroupSlides = document.querySelectorAll('.time-group');
      } else {
        timeList.innerText = "An error occurred. Please try again later.";
        dateDisplay.innerText = "Error";
        dayNext.classList.remove('active');
        weekNext.classList.remove('active');
        next.classList.remove('active');
      }
    })
    .catch(error => {
      timeList.innerText = "A fetch error occurred. Please try again later.";
      dateDisplay.innerText = "Error";
      dayNext.classList.remove('active');
      weekNext.classList.remove('active');
      next.classList.remove('active');
    });

  document.querySelector('.schedule-appointment__header > h3').innerText = `Request a tour at ${propertyTitle} below`;
  const bedList = document.getElementById('bedroom-list');
  bedList.innerHTML = "";

  const yearOptions = document.getElementById("year-options");
  const yearOptionsMobile = document.getElementById("moving_year_mobile");

  yearOptions.innerHTML = "";
  yearOptionsMobile.innerHTML = "";

  const addYear = new Date();

  yearOptionsMobile.appendChild(createButtonMobile('Year', 0));
  for (let index = 0; index < 2; index++) {
      addYear.setDate(addYear.getDate() + (365 * index));
      yearOptions.appendChild(createButton(addYear.getFullYear(), handleYearSelect));
      yearOptionsMobile.appendChild(createButtonMobile(addYear.getFullYear(), addYear.getFullYear()));
  }

  yearOptionsMobile.addEventListener('change', handleYearSelect);

  propertyBeds.forEach((bed, index) => {
    let bedSplit = bed.split(" ");
    const bedItem = document.createElement('LI');
    bedItem.classList.add("bedroom-filters__option");
    const bedWrapper = document.createElement('DIV');
    bedWrapper.classList.add("input-wrapper");
    const bedCheckbox = document.createElement('INPUT');
    bedCheckbox.setAttribute("id", bed.replace(" ",""));
    bedCheckbox.setAttribute("name", index);
    bedCheckbox.setAttribute("role", "checkbox");
    bedCheckbox.setAttribute("type", "checkbox");
    bedCheckbox.setAttribute("value", isNaN(bedSplit[0]) ? '0' : bedSplit[0] );
    const bedLabel = document.createElement("LABEL");
    bedLabel.setAttribute("for", bed.replace(" ",""));
    bedLabel.classList.add("checkbox-label");
    bedLabel.innerText = bed;
    bedWrapper.appendChild(bedCheckbox);
    bedWrapper.appendChild(bedLabel)
    bedItem.appendChild(bedWrapper);
    bedList.appendChild(bedItem);
  })
}

document.querySelectorAll('#day-options button').forEach((item) => {
  item.addEventListener('click', handleDropSelectDay);
})

document.querySelectorAll('#moving_day_mobile').forEach((item) => {
  item.addEventListener('change', handleDropSelectDay);
})

const createButton = (value, callback) => {
  const btn = document.createElement('BUTTON');
  btn.classList.add("date-sort__list-cta-wrapper");
  const btnSpan = document.createElement('SPAN');
  btnSpan.classList.add("p1", "date-sort__list-cta");
  btnSpan.innerText = value;
  const btnIcon = document.createElement('I');
  btnIcon.setAttribute("aria-hidden","true");
  btnIcon.classList.add("icon-checkmark", "date-sort__list-cta-icon");
  btn.addEventListener('click', callback);
  btn.appendChild(btnSpan);
  btn.appendChild(btnSpan);
  return btn;
}

const createButtonMobile = (value, index) => {
  const yearMobileOption = document.createElement('OPTION');
  yearMobileOption.setAttribute("value", index);
  yearMobileOption.innerText = value;
  return yearMobileOption;
}

if(appt){
  formFields.forEach((item) => {
    let target = document.getElementById(item);
    let isComplete = target.value.length > 0;
    target.parentElement.classList.toggle('complete', isComplete);
  })

  const step1Valid = () => {
    let isValid = true;
    step1Values.first_name = document.getElementById('first_name').value.length > 0 ? document.getElementById('first_name').value : false;
    step1Values.last_name = document.getElementById('last_name').value.length > 0 ? document.getElementById('last_name').value : false;
    step1Values.email_address = document.getElementById('email_address').value.length > 0 && validEmail(document.getElementById('email_address').value) ? document.getElementById('email_address').value : false;
    step1Values.phone_number = document.getElementById('phone_number').value.length > 0 && validPhone(document.getElementById('phone_number').value) ? document.getElementById('phone_number').value : false;

    Object.keys(step1Values).forEach((key) => {
      if(!step1Values[key]){
        isValid = false;
        if(key != 'tour_type') document.getElementById(key).parentElement.classList.add('error');
      } else {
        if(key != 'tour_type') document.getElementById(key).parentElement.classList.remove('error');
      }
    });

    return isValid;
  }

  const step2Valid = () => {
    let isValid = true, bedrooms = [];
    const bedroomsInput = document.querySelectorAll('.schedule-appointment__bedrooms input[type="checkbox"]');

    bedroomsInput.forEach((item) => {
      if(item.checked) bedrooms.push(item.value);
    });

    step2Values.bedrooms = bedrooms.length > 0 ? bedrooms : false;

    if(isMobile){
      step2Values.moving_month = document.getElementById('moving_month_mobile').value != 0 ? document.getElementById('moving_month_mobile').options[document.getElementById('moving_month_mobile').selectedIndex].text : false;
      step2Values.moving_day = document.getElementById('moving_day_mobile').value != 0 ? document.getElementById('moving_day_mobile').value : false;
      step2Values.moving_year = document.getElementById('moving_year_mobile').value != 0 ? document.getElementById('moving_year_mobile').value : false;
    } else {
      step2Values.moving_month = document.getElementById('moving_month').classList.contains('valid') ? document.getElementById('moving_month').innerText : false;
      step2Values.moving_day = document.getElementById('moving_day').classList.contains('valid') ? document.getElementById('moving_day').innerText : false;
      step2Values.moving_year = document.getElementById('moving_year').classList.contains('valid') ? document.getElementById('moving_year').innerText : false;
    }

    if(!step2Values.bedrooms){
      isValid = false;
      document.querySelector('.schedule-appointment__bedrooms').classList.add('error');
    } else {
      document.querySelector('.schedule-appointment__bedrooms').classList.remove('error');
    }

    if(!(step2Values.moving_month && step2Values.moving_day && step2Values.moving_year)){
      isValid = false;
      document.querySelector('.schedule-appointment__moving').classList.add('error');
    } else {
      const today = new Date();
      const movingDate = new Date(`${step2Values.moving_month} ${step2Values.moving_day}, ${step2Values.moving_year} ${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`);

      if(movingDate > today){
        document.querySelector('.schedule-appointment__moving').classList.remove('error');
      } else {
        isValid = false;
        document.querySelector('.schedule-appointment__moving').classList.add('error');
      }
    }

    if(!step2Values.captchaResponse){
      isValid = false;
      document.getElementById('myCaptcha').classList.add('error');
    } else {
      document.getElementById('myCaptcha').classList.remove('error');
    }

    return isValid;
  }

  const handleNext = (e) => {
    if(step1Valid()){
      e.currentTarget.classList.remove('active');
      step1.classList.remove('active');
      step2.classList.add('active');
      document.querySelector('.greeting').innerText = `Hello, ${step1Values.first_name}! You have requested to tour with us on ${step1Values.tour_time.date} at ${step1Values.tour_time.time}.`;

      prev.classList.add('active');
      submit.classList.add('active');
      step1span.forEach((item) => {
        item.classList.remove('active');
      })
      step2span.forEach((item) => {
        item.classList.add('active');
      })
      document.querySelector('.scroll-container').scrollTo(0,0);
    }
  }

  next.addEventListener('click', handleNext);

  const handlePrev = (e) => {
    prev.classList.remove('active');
    step1.classList.add('active');
    step2.classList.remove('active');
    next.classList.add('active');
    submit.classList.remove('active');
    step1span.forEach((item) => {
      item.classList.add('active');
    })
    step2span.forEach((item) => {
      item.classList.remove('active');
    })
    const scrollContainer = document.querySelector('.scroll-container');
    if(scrollContainer) scrollContainer.scrollTo(0,0);
  }

  prev.addEventListener('click', handlePrev);

  const handleSubmit = (e) => {
    if(step2Valid()){
      let dateParse = Date.parse(step1Values.tour_time.date);
      let date = new Date(dateParse);

      const submitDate = addHours(date, step1Values.tour_time.time);

      let formData = {};
      formData.PropertyId = propertyId;
      formData.FirstName = step1Values.first_name;
      formData.LastName = step1Values.last_name;
      formData.Email = step1Values.email_address;
      formData.Phone = step1Values.phone_number;
      formData.TextUpdates = document.getElementById('optin').checked;

      // This should change
      formData.VisitTime = submitDate ? submitDate.toISOString() : '';

      formData.selectedDate = date.toISOString();
      formData.selectedTime = step1Values.tour_time.time;
      formData.getTimezoneOffset = date.getTimezoneOffset();
      formData.agent = window.navigator.userAgent;
      formData.DNIValue = document.getElementById('DNIValue') ? document.getElementById('DNIValue').value : '';
      formData.CaptchaResponse = step2Values.captchaResponse;
      formData.tourType = step1Values.tour_type;
      formData.UTM = document.getElementById('utm') ? document.getElementById('utm').value : '';

      formData.Bedrooms = step2Values.bedrooms.toString();
      formData.Comments = document.querySelector('.schedule-appointment__notes textarea').value > 0 ? document.querySelector('.schedule-appointment__notes textarea').values : '';

      let moveDate = isValidDate({
        day: step2Values.moving_day,
        month: step2Values.moving_month,
        year: step2Values.moving_year
      });

      moveDate ? formData.MoveInDate = moveDate.toISOString() : null;

      let fetchOptions;

      if(isLocalhost()) {
        fetchOptions = {};
      } else {
        fetchOptions = {
          method: boardingPassMethod,
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }
      }

      fetch(boardingPassEndpoint, fetchOptions)
        .then(function (response) {
          if (response.ok) {
            return response.json();
          }
        })
        .then(function (json) {
          const confTitle = document.querySelector('.schedule-confirmation__title');
          const confDescription = document.querySelector('.schedule-confirmation__text');
          const confLink = document.querySelector('.schedule-confirmation__details');

          if (json && json.success) {
            confTitle.innerText = confTitleText;
            confDescription.innerText = confResponseText;
            confLink.innerText = "View Tour Details";
            // self.formState = 'success';
            json.boardingPassId ? confBoardingPassUrl = `${boardingPassUrl}?boardingpassid=${json.boardingPassId}` : null;
            confLink.setAttribute("href", confBoardingPassUrl);
            window.uetq = window.uetq || [];
            window.uetq.push('event', 'ScheduleAVisit', { 'event_category': 'ScheduleAVisit', 'event_label': 'ScheduleAVisit', 'event_value': '1' });
            var metaEventNames = 'Lead, Schedule_MAA';
            metaEventNames.split(',').forEach(async (metaEventName) => {
              metaEvent(metaEventName);
            });
          } else {
            confTitle.innerText = errTitleText;
            confDescription.innerText = json.errResponse;
            confLink.style.display = "none";
          }

          step2.classList.remove('active');
          step3.classList.add('active');
          submit.classList.remove('active');
          done.classList.add('active');
          step2span.forEach((item) => {
            item.classList.remove('active');
          })
          prev.classList.remove('active');
          document.querySelector('.scroll-container').scrollTo(0,0);
        })
    }
  }

  submit.addEventListener('click', handleSubmit);
  done.addEventListener('click', closeModal);

  const handleDropdown = (e) => {
    dropLists.forEach((item) => {
      item == e.currentTarget.nextElementSibling ? item.classList.toggle('active') : item.classList.remove('active');
    })
  }

  dropitems.forEach((item) => {
    item.addEventListener('click', handleDropdown);
  })

  const handleTourType = (e) => {
    step1.classList.add('active');
    tourType.forEach((item) => {
      if(item == e.currentTarget) {
        item.classList.add('buttonSchedTourACTIVE');
        item.classList.remove('buttonSchedTourINACTIVE');
        step1Values.tour_type = item.innerText;
      } else {
        item.classList.remove('buttonSchedTourACTIVE');
        item.classList.add('buttonSchedTourINACTIVE');
      }
    })
  }

  tourType.forEach((item) => {
    item.addEventListener('click', handleTourType)
  })

  const handleDayNav = (e) => {
    document.querySelector('.time-group.active').classList.remove('active');

    if(e.currentTarget.classList.contains('next')){
      if(timeGroupIndex < timeGroupSlides.length - 1){
        timeGroupIndex++;
        dayPrev.classList.add('active');
        if(timeGroupIndex >= timeGroupSlides.length - 1) dayNext.classList.remove('active');
      } else {
        dayPrev.classList.add('active');
      }
    } else {
      if(timeGroupIndex > 0){
        timeGroupIndex--;
        dayNext.classList.add('active');
        if(timeGroupIndex == 0) dayPrev.classList.remove('active');
      } else {
        dayNext.classList.add('active');
      }
    }

    timeGroupSlides[timeGroupIndex].classList.add('active');
    dateDisplay.innerText = timeGroupSlides[timeGroupIndex].getAttribute('data-title');
  }

  dayNext.addEventListener('click', handleDayNav);
  dayPrev.addEventListener('click', handleDayNav);

  const handleWeekNav = (e) => {
    document.querySelector('.time-group.active').classList.remove('active');

    if(e.currentTarget.classList.contains('next')){
      timeGroupIndex = timeGroupSlides.length - 1;
      dayNext.classList.remove('active');
      weekNext.classList.remove('active');
      dayPrev.classList.add('active');
      weekPrev.classList.add('active');
    } else {
      timeGroupIndex = 0;
      dayPrev.classList.remove('active');
      weekPrev.classList.remove('active');
      dayNext.classList.add('active');
      weekNext.classList.add('active');
    }

    timeGroupSlides[timeGroupIndex].classList.add('active');
    dateDisplay.innerText = timeGroupSlides[timeGroupIndex].getAttribute('data-title');
  }

  weekNext.addEventListener('click', handleWeekNav);
  weekPrev.addEventListener('click', handleWeekNav);

  const handleContactInputs = (e) => {
    e.currentTarget.parentElement.classList.toggle('complete', e.currentTarget.value.length > 0);
    switch (e.currentTarget.getAttribute('id')) {
      case 'email_address':
        e.currentTarget.parentElement.classList.toggle('error', !(validEmail(e.currentTarget.value) && e.currentTarget.value.length > 0));
        break;
      case 'phone_number':
        e.currentTarget.parentElement.classList.toggle('error', !(validPhone(e.currentTarget.value) && e.currentTarget.value.length > 0));
        break
      default:
        e.currentTarget.parentElement.classList.toggle('error', !e.currentTarget.value.length > 0);
        break;
    }
  }

  contactInputs.forEach((input) => {
    input.addEventListener('blur', handleContactInputs);
  })

  const validEmail = (email) => {
    return email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  };

  const validPhone = (phone) => {
    return phone.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/);
  }

  const addHours = (date, time) => {
    if (!date || !time) {
      return;
    }

    let hour = 0,
      minute = 0,
      dayTime = 0;

    dayTime = time.split(' ')[1];
    hour = +time.split(' ')[0].split(':')[0];
    minute = +time.split(' ')[0].split(':')[1];

    if (dayTime === 'PM') hour += 12;

    date.setHours(hour, minute - date.getTimezoneOffset(), 0);

    return date;
  }

  const isValidDate = ({ year, month, day }) => {
    if (year && month && day) {
      let todayDate = new Date();
      let compareDate = new Date(`${month} ${day}, ${year}`); //new Date(year, month - 1, day);

      if (compareDate > todayDate) {
        return compareDate;
      }
    }
  }

  const closeModal = () => {
    const modalGlobalEl = document.getElementById('global-modal');
    const body = document.body;
    if (modalGlobalEl) {
      modalGlobalEl.style.display = 'none';
      body.style.overflow = 'auto';
      document.removeEventListener('click', closeModal);
    }
    if (window.parent && window.parent.postMessage) {
      window.parent.postMessage(`close modal with id = global-modal`);
    }
  }

  done.addEventListener('click', closeModal);

  const getSHA256Hash = async (input) => {
    const textAsBuffer = new TextEncoder().encode(input);
    const hashBuffer =await window.crypto.subtle.digest('SHA-256', textAsBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hash = hashArray
      .map((item) => item.toString(16).padStart(2, '0'))
      .join('');
    return hash;
  }

  const getMetaTestCode = async () => {
    const response = await fetch('/api/event/getmetatestcode');
    const metaTestCode = await response.text();
    return metaTestCode;
  }

  const TrackMetaEvent = (event, value) => {
    // Track Meta Pixel event
    if (typeof fbq !== 'undefined') {
      fbq('track', event, value.data[0].user_data, { eventID: value.data[0].event_id });
    }

    console.log('meta-events event: ' + event);
    console.log('meta-events value:');
    console.log(value);
    //Track Meta Server Event
    trackMetaServerEvent(value);
  }

  const trackMetaServerEvent = async (eventJson) => {
    try {
      const response = await fetch('/api/event/trackmetaserverevent', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(eventJson)
      });
      const data = await response.json();
      console.log(data);
      return data;
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const getCookieValue= (cookieName) => {
    var cookieStr = decodeURIComponent(document.cookie);
    var cookieArr = cookieStr.split(';');
    for (var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split('=');
      var name = cookiePair[0].trim();
      if (name === cookieName) {
        var value = cookiePair[1];
        return value;
      }
    } return null;
  }

  const generateUUID = () => {
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = ((dt + Math.random() * 16) % 16) | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }

  const getClientIP = async () => {
    const response = await fetch('/api/event/getip');
    const ip = await response.text();
    return ip;
  }

  const metaEvent = async (metaEventName) => {
    var fbclid = getCookieValue('_fbc');
    var fbp = getCookieValue('_fbp');
    console.log('fbclid: ' + fbclid + '; fbp: ' + fbp);
    let self = this;

    var metaServerEvent = {
      'data': [{
        'event_name': metaEventName,
        'event_time': Math.floor(Date.now() / 1000),
        'action_source': 'website',
        'event_id': generateUUID(),
        'user_data': {
          'client_ip_address':await getClientIP(),
          'client_user_agent': navigator.userAgent
        }
      }]
    };

    var hashedFirstName = step1Values.first_name ? await getSHA256Hash(step1Values.first_name) : null;
    var hashedLastName = step1Values.last_name ? await getSHA256Hash(step1Values.last_name) : null;
    var hashedEmail = step1Values.email_address ? await getSHA256Hash(step1Values.email_address) : null;
    var hashedPhone = step1Values.phone_number ? await getSHA256Hash(step1Values.phone_number) : null;
    var testEventCode = await  getMetaTestCode();

    if (hashedFirstName !== null) {
      metaServerEvent.data[0].user_data.fn = [hashedFirstName];
    }
    if (hashedLastName !== null) {
      metaServerEvent.data[0].user_data.ln = [hashedLastName];
    }
    if (hashedEmail !== null) {
      metaServerEvent.data[0].user_data.em = [hashedEmail];
    }
    if (hashedPhone !== null) {
      metaServerEvent.data[0].user_data.ph = [hashedPhone];
    }
    if (fbclid !== null) {
      metaServerEvent.data[0].user_data.fbc = fbclid;
    }
    if (fbp !== null) {
      metaServerEvent.data[0].user_data.fbp = fbp;
    }

    if (testEventCode !== null) {
      metaServerEvent.test_event_code = testEventCode;
    }

    console.log('Meta Server Event Built by Schedule_MAA Listener:');
    console.log(metaServerEvent);

     // Call Meta-Events Function
    TrackMetaEvent(metaEventName, metaServerEvent);
  }

  window.setTimeout(() => {
    if(urlParams.has("scheduleatour") && urlParams.get('scheduleatour') == "true"){
      initAppointment();
    }
  }, 200);

  const handleDropSelectMonth = (e) => {
    let setMonth;

    if(isMobile){
      setMonth = document.getElementById('moving_month_mobile').value;
    } else {
      //document.getElementById('moving_day').innerText = "Day";
      setMonth = e.currentTarget.querySelector('.date-sort__list-cta').innerText;
    }

    step2Values.moving_month = setMonth;

    if(!isMobile){
      e.currentTarget.closest('.date-sort').querySelector('.date-sort__cta-text').innerText = setMonth;
      e.currentTarget.closest('.date-sort').querySelector('.date-sort__cta-text').classList.add('valid');
      e.currentTarget.closest('.date-sort__list').classList.remove('active');
    }

    setDays();
  }

  monthSelect.forEach((item) => {
    item.addEventListener('click', handleDropSelectMonth);
  })

  document.getElementById('moving_month_mobile').addEventListener('change', handleDropSelectMonth);
  //document.getElementById('moving_year_mobile').addEventListener('change', setDays);

  document.addEventListener('closeModalEvent', ((e) => {
    if(e.detail.id && e.detail.id.includes(MODAL_UNIQUE_ID)){
      handlePrev();
    }
  }));
}



// WEBPACK FOOTER //
// ./src/templates/components/schedule-appointment/schedule-appointment.js